import React, { useEffect, useRef, useState } from "react";
import PhysicalTab from "./PhysicalTab";
import Buttons from "../../../../components/UI/Buttons";
import WithRouter from "../../../../hoc/WithRouter";
import { isSet } from "../../../../utils/commonUtils";
import UploadPhysical from "../../EmployeeVisitDetailView/RightContent/UploadPhysical";
import SplitedTab from "./SplitedTab";
import SwipeableViews from 'react-swipeable-views';
import DropDownService from "../../../../services/DropDownService";
import FullScreenMode from "../../../../components/UI/FullScreenMode";
import { isLaboratoryVisitCategory } from "../../../../utils/visitUtils";
import StatusBar from "./PhysicalTab/StatusBar";
import SearchOverAllStatus from "./SearchOverAllStatus";
import VaccinesTab from "../../EmployeeVisitDetailView/RightContent/VaccinesTab"
import LaboratoryTab from "../../EmployeeVisitDetailView/RightContent/LaboratoryTab"
import SpecialInstructionTab from "../../EmployeeVisitDetailView/RightContent/SpecialInstructionTab"
import Icons from "../../../../components/UI/Icons";

const NewRightContent = ({ 
  params, 
  visitDetails, 
  fetchVisitDetails, 
  employeeDetails, 
  companyDetails, 
  lookupsOptions, 
  stateList,
  employeeId,
  fetchEmployeeDetails,
  isLeftSidebarCollapsed,
  ...props
}) => {
  const scrollerRef = useRef(null);
  const [inactiveLeft, setInactiveLeft] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState('');
  const [tabHeaders,setTabHeaders] = useState([]);
  const [selectedValue, setSelectedValue] = useState(0);
  const [physicalOption,setPhysicalOption]=useState([]);
  const [visitcategory,setVisitCategory]=useState('');
  useEffect(()=>{
   if(Object.entries(visitDetails).length>0 && visitDetails.visit_category!==visitcategory){
    setVisitCategory(visitDetails.visit_category); //to prevent un wanted render 
    const tabs = isLaboratoryVisitCategory(visitDetails.visit_category) ?
    [
      { label: "Laboratory", key: "laboratory", component: LaboratoryTab },
      { label: "Vaccines", key: "vaccines", component: VaccinesTab },
      { label: "Instructions", key: "", component: SpecialInstructionTab },
    ] :
    [
      { label: "Physical", key: "", component: PhysicalTab },
      // { label: "Drugs/Alcohol", key: "drugsOrAlcohol", component: SplitedTab },
      // { label: "Laboratory", key: "laboratory", component: SplitedTab },
      // { label: "Vaccines", key: "vaccines", component: SplitedTab },
      // { label: "Tests/Screenings", key: "testsOrScreenings", component: SplitedTab },
      // { label: "Radiology", key: "radiology", component: SplitedTab },
      // { label: "Provider Exam", key: "providerExam", component: SplitedTab },
      { label: "Images", key: "", component: UploadPhysical },
      { label: "Instructions", key: "", component: SpecialInstructionTab },
      // { label:"Clearance Report",key:'',component: SpecialInstructionTab  }

    ];
    if(isLaboratoryVisitCategory(visitDetails.visit_category)){
      setSelectedTab('Laboratory');
    }else{
      setSelectedTab('Physical');
    }
    setTabHeaders(tabs);
   }
   
  },[visitDetails,visitcategory]);
  useEffect(()=>{
    fetchPhysicalOptions();
  },[]);
  const fetchPhysicalOptions=async()=>{
    let activitiesResponse=await DropDownService.getActivityDropdownList(null);
    // console.log('activitiesResponse',activitiesResponse);
      let options=[{label:'-Select-',value:''}];
      activitiesResponse.forEach(val => {
        options.push({label:val.activity_name,value:val.actitivity_id});
      });
    setPhysicalOption(options);
  }

  // useEffect(() => {
  //   const checkScroller = () => {
  //     setInactiveLeft(scrollerRef.current.scrollLeft === 0);
  //   };

  //   const handleScroll = () => {
  //     setInactiveLeft(scrollerRef.current.scrollLeft === 0);
  //   };

  //   checkScroller();
  //   if (scrollerRef.current) {
  //     scrollerRef.current.addEventListener("scroll", handleScroll);
  //   }
  //   return () => {
  //     if (scrollerRef.current) {
  //       scrollerRef.current.removeEventListener("scroll", handleScroll);
  //     }
  //   };
  // }, []);

  const handleRightClick = () => {
    scrollerRef.current.scrollBy({
      left: 200,
      behavior: "smooth"
    });
  };

  const handleLeftClick = () => {
    scrollerRef.current.scrollBy({
      left: -200,
      behavior: "smooth"
    });
  };

  const handleTabClick = (label, index) => {
    setSelectedTab(label);
    setSelectedValue(index);
  };

  const handleChangeIndex = (index) => {
    setSelectedValue(index);
    setSelectedTab(tabHeaders[index].label);
  };

  // const SelectedComponent = tabHeaders[selectedValue]?.component;
  const SelectedComponent = tabHeaders.find((header) => header&&header.label === selectedTab);

  const renderTabRail = (closeOnSelect = false) => (
    <ul className="nav nav-borders flex-column sh_vertnavbar nav-tabs border-0">
      {tabHeaders.map((header, headerInd) => header && (
        <li key={headerInd}>
          <a
            data-bs-toggle="tab"
            className={`nav-link ${selectedTab === header.label ? "active" : ""}`}
            onClick={() => {
              handleTabClick(header.label, headerInd);
              if (closeOnSelect) setIsNavOpen(false);
            }}
          >
            <span className="mr-2">
              <Icons type={selectedTab === header.label ? "ActivePlay" : "Play"} />
            </span>
            {header.label}
          </a>
        </li>
      ))}
    </ul>
  );


  return (
    <div className={`px-2 sh_visitMainContentWrap ${isLeftSidebarCollapsed ? "sh_visitMainContentWrapExpanded" : ""}`}>
      <div className="sh_cardBox h-100 sh_cardbglight">
        {/* <div className="sh_cardHeader" style={{ position: "relative" , padding: "6px"}}>
          <div className="form-group d-flex mb-0 justify-content-between align-items-center">
           <div className="d-flex align-items-center"> 
              <h6 className="text-lg f-500 mb-0">
                <Buttons
                className="badge back_btn ml-3 "
                  label={"Back"}
                  iconType={"Back"}
                  acl={"any"}
                  href={
                    isSet(params.patientId, null) !== null
                      ? `/employee/visit-history/${params.patientId}/${params.patientDetails}`
                      : (isSet(params.backTo, null)!=null)? `/${params.backTo}`
                      :"/visits"
                  }
                  hrefState={props?.location?.state}
                />
            </h6>
            </div>
            <TabNavigation
              handleLeftClick={handleLeftClick}
              handleRightClick={handleRightClick}
              tabHeaders={tabHeaders}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
              scrollerRef={scrollerRef}
              inactiveLeft={inactiveLeft}
              selectedValue={selectedValue}
            />
            <FullScreenMode />
          </div>
        </div> */}
        <div className="sh_cardBody">
          {/* Tablet/small: right-edge offcanvas nav toggle */}
          <button
            type="button"
            className="sh_topNavToggleBtn"
            onClick={() => setIsNavOpen((prevState) => !prevState)}
            aria-label={isNavOpen ? 'Close navigation panel' : 'Open navigation panel'}
          >
            {isNavOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="none"
                stroke="#141B34"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11.5 18C11.5 18 5.50001 13.5811 5.5 12C5.49999 10.4188 11.5 6 11.5 6" />
                <path d="M18.5 18C18.5 18 12.5 13.5811 12.5 12C12.5 10.4188 18.5 6 18.5 6" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12.5 18C12.5 18 18.5 13.5811 18.5 12C18.5 10.4188 12.5 6 12.5 6" />
                <path d="M5.50005 18C5.50005 18 11.5 13.5811 11.5 12C11.5 10.4188 5.5 6 5.5 6" />
              </svg>
            )}
          </button>

          <div
            className={`sh_topNavBackdrop ${isNavOpen ? 'show' : ''}`}
            onClick={() => setIsNavOpen(false)}
          />

          <div className={`sh_topNavOffcanvas ${isNavOpen ? 'open' : ''}`}>
            <div className="sh_topNavOffcanvasHeader">
              <button
                type="button"
                className="sh_topNavCloseBtn"
                onClick={() => setIsNavOpen(false)}
                aria-label="Close navigation panel"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085"></path></svg>
              </button>
            </div>
            <div className="sh_topNavOffcanvasBody">
              {renderTabRail(true)}
            </div>
          </div>
          {/* {
            selectedComponent ? (
              <selectedComponent.component
                visitDetails={visitDetails}
                fetchVisitDetails={fetchVisitDetails}
                employeeDetails={employeeDetails}
                companyDetails={companyDetails}
                lookupsOptions={lookupsOptions}
                stateList={stateList}
                tabName={selectedTab}
                tabId={selectedComponent.key}
              />
            ) : null
          } */}
          {/* <ActiveComponent /> */}
          {/* <SwipeableViews
            axis={'x'}
            // enableMouseEvents
            index={selectedValue}
            onChangeIndex={handleChangeIndex}
            springConfig={{
              duration: '0.6s', // Duration of the swipe animation
              easeFunction: 'ease-out', // Easing function for the animation
              delay: '0s', // Delay before starting the animation
            }}
          > */}
          <div className="row">
            {/* tabnavigation */}
            <div className="col-lg-2 col-6 sh_topNavDesktop">
              {renderTabRail(false)}
            </div>
            {/* <div class="col-lg-3 col-6 ">
              <ul class="nav nav-borders flex-column sh_vertnavbar nav-tabs border-0">
                <li><a class="nav-link ">
                  <span class="">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="24" height="24" rx="12" fill="#20E57D"></rect>
                      <path d="M7.33337 12.6667L9.68432 14.5475C10.2359 14.9887 11.0358 14.9233 11.5083 14.3983L16.6667 8.66675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>

                  </span> Physical</a>
                </li>
                <li><a class="nav-link active"><span class="nav-count">2</span> Images</a></li>
                <li><a class="nav-link "><span class="nav-count">3</span> Instructions</a></li>
                <li><a class="nav-link "><span class="nav-count">4</span> Clearance Report</a></li>

              </ul>
            </div> */}
            {/* componentview */}
          

            {/* </div> */}
         
            {/* {tabHeaders.map((header, index) => (
              // <div
              //   key={index}
              //   role="tabpanel"
              //   title={header.label}
              //   hidden={selectedValue !== index}
              //   id={`full-width-tabpanel-${index}`}
              //   aria-labelledby={`full-width-tab-${index}`}
              // > */}
                <div className={`col-12 sh_visitMainContentCol ${isLeftSidebarCollapsed ? "col-lg-10" : "col-lg-10"}`}> 
                  
                  <div>
                {
            SelectedComponent ? (
              <SelectedComponent.component
                visitDetails={visitDetails}
                fetchVisitDetails={fetchVisitDetails}
                employeeDetails={employeeDetails}
                companyDetails={companyDetails}
                lookupsOptions={lookupsOptions}
                stateList={stateList}
                tabName={selectedTab}
                tabId={SelectedComponent.key}
                physicalOption={physicalOption}
                employeeId={employeeId}
                fetchEmployeeDetails={fetchEmployeeDetails}
              />
            ) : null
          }
              </div>
            {/* ))} */}
          {/* </SwipeableViews> */}
           {/* <StatusBar visitDetails={visitDetails} /> */}
          </div>
             
        </div>
      </div>
       </div>
    </div>
  );
};

export default WithRouter(NewRightContent);
